//import Vue from 'vue'

const state = {
}

const getters = {
    type2variant(state) {
        return (type) => {
            const table = {
                'from': 'primary',
                'to': 'success',
                'importer': 'info',
            }
            return table[type]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/shipping_items' + (data.id ? '/' + data.id : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

//        const response = await axios.post('/api/v1/shipping_items' + (data.id ? '/' + data.id : ''), data)
//            .catch(error => error.response || null)
//        return response
    },
    async destroy (context, data) {
        if (data.id === undefined) {
            return {
                data: {
                    data: {
                    },
                },
            }
        }
        const response = await axios.delete('/api/v1/shipping_items/' + data.id)
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        const response = await axios.get('/api/v1/shipping_items' + (typeof data  === 'string' ? '/' + data : ''), {
            params: (typeof data === 'object' ? data : null)
        })
        .catch(error => error.response || null)
        return response
    },
    async list_item (context, data) {
        const response = await axios.post('/api/v1/shipping_items/' + data.uuid + '/list_item/' + data.provider, data)
            .catch(error => error.response || null)

        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

